import { render, staticRenderFns } from "./indexAuthView.vue?vue&type=template&id=64f0566d&"
import script from "./indexAuthView.vue?vue&type=script&lang=js&"
export * from "./indexAuthView.vue?vue&type=script&lang=js&"
import style0 from "./indexAuthView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports